package link.erpango.quip.domain.entities
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class DMaintenance(
    val id: Long?, // Backend ID
    @Transient
    val localId: Long? = null, // Database PK
    @SerialName("vehicle_vin")
    val vehicleVin: String,
    val kilometers: Int,
    val description: String,
    @SerialName("spare_parts")
    var spareParts: List<DSparePart>,
    val mechanic: String,
    val workshop: String,
    val cost: Double,
    val date: Long, // Fecha en milisegundos desde 1970
    val signature: String? = null
) {
    val isSigned: Boolean get() = !signature.isNullOrBlank()
}

@Serializable
data class DVehicleMaintenance(
    val vehicle: DVehicle,
    val maintenances: DMaintenance
)